import { useNavigate } from 'react-router';
import { useModalContext } from 'src/hooks/useModalContext';
import { useRoute } from 'src/router/hooks/useRoute';

type StartAuthFlowParams = {
  props?: { [key: string]: unknown };
  replace?: boolean;
  defaultFlow?: boolean;
  onSuccess?: () => void;
};

type handleSuccessProps = Omit<StartAuthFlowParams, 'replace' | 'props'>;

export const useAuthFlow = () => {
  const { openModal } = useModalContext();
  const navigate = useNavigate();
  const { ROUTE } = useRoute();

  const handleSuccess = ({ defaultFlow, onSuccess }: handleSuccessProps) => {
    if (defaultFlow) {
      return () => navigate(ROUTE.GAMES.get('top'));
    }
    if (onSuccess) {
      return onSuccess;
    }
  };

  const startLogin = ({ props = {}, replace, onSuccess }: StartAuthFlowParams = {}) => {
    openModal('LOGIN', { props: { ...props, onAuthFlowSuccess: onSuccess }, replace });
  };

  const startRegistration = ({
    props = {},
    replace,
    onSuccess,
    defaultFlow = true
  }: StartAuthFlowParams = {}) => {
    openModal('SIGNUP', {
      props: {
        ...props,
        onAuthFlowSuccess: handleSuccess({ defaultFlow, onSuccess })
      },
      replace
    });
  };

  return {
    startLogin,
    startRegistration
  };
};
